import React from 'react';
import ContactPage from '../../pages/ContactPage';

const ContactDesktop = () => <ContactPage />;

export default ContactDesktop;
